import React from 'react';
import Card from '../../../reusableComponents/cards/Card71';
import LearningPathsList from './LearningPaths';

const EnrolledCourses = () => {
  // Custom components for each swap section
  const LearningPathsContent = () => (
    <div className="w-full">
      <LearningPathsList />
    </div>
  );

  const CompletedCoursesContent = () => (
    <div className="w-full">
      <p>Your completed courses will appear here.</p>
      {/* You can replace this with another component if needed */}
    </div>
  );

  return (
    <div className="max-w-full">
      <Card
        title="Enrolled Courses"
        showTitle={true}
        // Hide buttons we don't need
        showPrimaryButton={false}
        showSecondaryButton={false}
        showMenuButton={false}
        
        // Show swap components with custom labels
        showSwapComponent1={true}
        showSwapComponent2={false}
        showSwapComponent3={false}
        swapLabel1="Learning Paths"
        swapLabel2="Completed Courses"
        
        // Pass custom content to display based on active swap
        swapContent1={<LearningPathsContent />}
        // swapContent2={<CompletedCoursesContent />}
        
        // Hide default description
        showDescription={false}
        
        width="w-full"
        onMenuClick={() => console.log("Menu options")}
      />
    </div>
  );
};

export default EnrolledCourses;